import { hasRoleAdmin } from 'common/utility/userRoles';

import { SR_API_ACTION_UTILITY_ANNOUNCEMENT_SHOULD_SHOW } from 'api/utilityActionTypes';

export default async function shouldShow({ state, utilityApiClient }, { utilityPartnerId, type }) {
  const utilityUser = state.get('utilityUser');
  if (!utilityUser || hasRoleAdmin(utilityUser.roles || [])) {
    return;
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ANNOUNCEMENT_SHOULD_SHOW,
    state: state,
    payload: {
      utilityPartnerId,
      utilityUserId: utilityUser.id,
      type,
    },
    onSuccess(shouldShow) {
      state.set(
        ['utilityAnnouncements', 'byPartnerId', utilityPartnerId, utilityUser.id, type],
        shouldShow,
      );
      return shouldShow;
    },
  });
}
